module.exports = __webpack_public_path__ + "static/media/Flow-green-tick-2.d83af631.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Flow/images/Flow-green-tick-2.svg
// module id = 1505
// module chunks = 0